// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"576":"m_main","599":"p_main"}[chunkId] + "." + {"576":"add6c764","599":"056807d7"}[chunkId] + ".chunk.css";
};